
import { Popover, Text} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { InfoCircle  } from 'tabler-icons-react';

import intl from "react-intl-universal";



export function IDAustriashowAdress(props:any) {
  const [opened, { close, open }] = useDisclosure(false);

if (props.adress === null) {
  return (
    <>
      <Text size="sm">{intl.get('IDA_DATA_NOADDRES')}</Text>
    </>)
}  
 
 const idaustriaadress = props.adress
 const nation =props.nation
 
 let stiege ="-"
 let tuer = "-"
 if (idaustriaadress.stiege !== null) {
    stiege = idaustriaadress.stiege
  }
if (idaustriaadress.tuer !== null) {
    tuer = idaustriaadress.tuer 
  }

  return (
    <>
<Popover width={250} position="bottom" withArrow shadow="md" opened={opened}>
      <Popover.Target>
          <Text onMouseEnter={open} onMouseLeave={close} td="underline">{nation} {idaustriaadress.postleitzahl} {idaustriaadress.gemeindebezeichnung} <InfoCircle size={18}/></Text>
        </Popover.Target>
      <Popover.Dropdown sx={{ pointerEvents: 'none' }}>
      <Text size="sm">{intl.get('IDA_DATA_STRASSE')}: <strong>{idaustriaadress.strasse}</strong></Text>
        <Text size="sm">{intl.get('IDA_DATA_HAUSNUMMER')}: <strong>{idaustriaadress.hausnummer}</strong></Text>
        <Text size="sm">{intl.get('IDA_DATA_STIEGE')}: <strong>{stiege}</strong></Text>
        <Text size="sm">{intl.get('IDA_DATA_TUER')}: <strong>{tuer}</strong></Text>
        <Text size="sm">{intl.get('IDA_DATA_PLZ')}: <strong>{idaustriaadress.postleitzahl}</strong></Text>
        <Text size="sm">{intl.get('IDA_DATA_ORT')}: <strong>{idaustriaadress.ortschaft}</strong></Text>
        <Text size="sm">{intl.get('IDA_DATA_GEMEINDE')}: <strong>{idaustriaadress.gemeindebezeichnung}</strong></Text>
        <Text size="sm">{intl.get('IDA_DATA_GEMEINDEZ')}: <strong>{idaustriaadress.gemeindekennziffer}</strong></Text>
      </Popover.Dropdown>
    </Popover>
    </>
  );
}